import {
  ASSETINSPECTIONCATEGORY_LOADING,
  GET_ASSETINSPECTIONCATEGORY,
  GET_ASSETINSPECTIONCATEGORY_SUCCESS,
  GET_ASSETINSPECTIONCATEGORY_FAIL,
  ADD_ASSETINSPECTIONCATEGORY_SUCCESS,
  ADD_ASSETINSPECTIONCATEGORY_FAIL,
  DELETE_ASSETINSPECTIONCATEGORY_SUCCESS,
  DELETE_ASSETINSPECTIONCATEGORY_FAIL,
  UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS,
  UPDATE_ASSETINSPECTIONCATEGORY_FAIL,
  ASSETINSPECTIONCATEGORY_RESET,
  ASSETINSPECTIONCATEGORY_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  assetInspectionCategories: [],
  assetInspectionCategoryAdded: {},
  error: {},
};

const AssetInspectionCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ASSETINSPECTIONCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ASSETINSPECTIONCATEGORY:
          return {
            ...state,
            assetInspectionCategories: action.payload.data,
            isAssetInspectionCategoryCreated: false,
            isAssetInspectionCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ASSETINSPECTIONCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_ASSETINSPECTIONCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAssetInspectionCategoryCreated: false,
            isAssetInspectionCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ASSETINSPECTIONCATEGORY: {
      return {
        ...state,
        isAssetInspectionCategoryCreated: false,
        loading: true,
      };
    }

    case ASSETINSPECTIONCATEGORY_LOADING: {
      return {
        ...state,
        isAssetInspectionCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_ASSETINSPECTIONCATEGORY_SUCCESS:
      return {
        ...state,
        isAssetInspectionCategoryCreated: true,
        loading: false,
        assetInspectionCategories: [action.payload.data, ...state.assetInspectionCategories],
        assetInspectionCategoryAdded: action.payload.data,
      };

    case ADD_ASSETINSPECTIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ASSETINSPECTIONCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        assetInspectionCategories: state.assetInspectionCategories.filter(
          assetInspectionCategory => assetInspectionCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ASSETINSPECTIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ASSETINSPECTIONCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        assetInspectionCategories: state.assetInspectionCategories.map(assetInspectionCategory =>
          assetInspectionCategory.id.toString() === action.payload.data.id.toString() ? { ...assetInspectionCategory, ...action.payload.data } : assetInspectionCategory
        ),
      };

    case UPDATE_ASSETINSPECTIONCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ASSETINSPECTIONCATEGORY_RESET_CREATE:
      return {
        ...state,
        isAssetInspectionCategoryCreated: false,
      };

    case ASSETINSPECTIONCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AssetInspectionCategory;